import React from 'react';
import {
  Paper,
  BottomNavigation as MuiBottomNavigation,
  BottomNavigationAction,
  Badge
} from '@mui/material';
import {
  MenuBook as MenuBookIcon,
  ShoppingCart as CartIcon
} from '@mui/icons-material';
import { ViewType } from '../../types';

interface BottomNavigationProps {
  currentView: ViewType;
  cartItemCount: number;
  onNavigationChange: (event: React.SyntheticEvent, value: ViewType | 'cart') => void;
}

const BottomNavigation: React.FC<BottomNavigationProps> = ({
  currentView,
  cartItemCount,
  onNavigationChange
}) => {
  return (
    <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1300 }} elevation={8}>
      <MuiBottomNavigation value={currentView} onChange={onNavigationChange} showLabels>
        <BottomNavigationAction label="Menu" value="menu" icon={<MenuBookIcon />} />
        <BottomNavigationAction
          label="Cart"
          value="cart"
          icon={
            <Badge badgeContent={cartItemCount} color="error">
              <CartIcon />
            </Badge>
          }
        />
      </MuiBottomNavigation>
    </Paper>
  );
};

export default BottomNavigation;
